import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles(theme => ({
  board: ({ totalColumns, hasAutoAccept }: Props) => ({
    display: 'none',
    [theme.breakpoints.up('md')]: {
      flex: '1 1 1px',
      height: '100%',
      width: '100%',
      padding: '0.75rem',
      display: 'grid',
      gap: '0.5rem',
      overflow: 'auto',
      justifyContent: 'center',
      gridTemplateRows: '100%',
      gridTemplateColumns: `repeat(${totalColumns}, minmax(6rem, ${
        hasAutoAccept ? '35rem' : '1fr'
      }))`,
      backgroundColor: neutral[10],
    },
  }),
  root: {
    flexDirection: 'column',
    display: 'flex',
    height: '100%',
  },
  swipeableViewsRoot: {
    height: '100%',
    '& div.react-swipeable-view-container': {
      height: '100%',
    },
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
}));

interface Props {
  totalColumns: number;
  hasAutoAccept: boolean;
}
